import { render, staticRenderFns } from "./ProcessDetail.html?vue&type=template&id=26022ca2&scoped=true&"
import script from "./ProcessTPARB.vue?vue&type=script&lang=js&"
export * from "./ProcessTPARB.vue?vue&type=script&lang=js&"
import style0 from "./ProcessDetail.scss?vue&type=style&index=0&id=26022ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26022ca2",
  null
  
)

export default component.exports